import Login from "./views/shared/Login.jsx";
import TrocarSenha from "./views/admin/seguranca/TrocarSenha.jsx";
import EsqueceuSenha from "./views/shared/EsqueceuSenha";

import DashBoard from "./views/admin/DashBoard.jsx";
import Home from "./views/admin/Home.jsx";

import AnaliseOrdemColetaList from "./views/admin/avaliacao-os/AnaliseOrdemColetaList";
import AnaliseOrdemColetaMap from "./views/admin/avaliacao-os/AnaliseOrdemColetaMap";
import OrdemColetaPesquisa from "./views/admin/coleta/OrdemColetaPesquisa";
import Monitoramento from "./views/admin/monitoramento/Monitoramento";
import MonitoramentoTV from "./views/admin/monitoramento/MonitoramentoTV";
import HistoricoList from "./views/admin/historico/HistoricoList.jsx";

import { faChartSimple, faMagnifyingGlass, faTv, faFileSignature, faHome } from '@fortawesome/free-solid-svg-icons';

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "",
    component: Login,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/esqueceusenha",
    name: "EsqueceuSenha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false
  }, 
   {
    path: "/home",
    name: "Home",
    icon: faHome,
    component: Home,
    layout: "/fiscal",
    sidebar: true
  },  
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: faChartSimple,
    component: DashBoard,
    layout: "/fiscal",
    sidebar: true
  },  
  {
    path: "/monitoramento",
    name: "Monitoramento",  
    icon: faTv,
    component: Monitoramento,
    layout: "/mapaordem",
    sidebar: true
  },  
  {
    path: "/ordemserviçopesquisa",
    name: "Pesquisa de Ordens",
    icon: faMagnifyingGlass,
    component: OrdemColetaPesquisa,
    layout: "/fiscal",
    sidebar: true
  },
  {
    path: "/historico",
    name: "Histórico de Execução",
    icon: faFileSignature,
    component: HistoricoList,
    layout: "/admin",
    sidebar: true
  },
  {
    path: "/monitoramentoTV",
    name: "Monitoramento TV",    
    component: MonitoramentoTV,    
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/analiseordem",
    name: "Análise de Ordem de Serviço",    
    component: AnaliseOrdemColetaList,
    layout: "/fiscal",
    sidebar: false
  },
  {
    path: "/analiseordemmap",
    name: "Mapa de Ordem de Serviço",    
    component: AnaliseOrdemColetaMap,    
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "Trocar Senha",
    icon: "",
    component: TrocarSenha,
    layout: "/fiscal",
    sidebar: false
  },
];

export default routes;
